var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRssLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H16C7.16344 0 0 7.16344 0 16V48C0 56.8366 7.16344 64 16 64H48C56.8366 64 64 56.8366 64 48V16C64 7.16344 56.8366 0 48 0Z",
    fill: "#008CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7143 25.7143C25.7143 25.2975 25.8799 24.8978 26.1746 24.6031C26.4693 24.3084 26.869 24.1429 27.2857 24.1429H38.2857C38.7025 24.1429 39.1022 24.3084 39.3969 24.6031C39.6916 24.8978 39.8572 25.2975 39.8572 25.7143V36.7143C39.8572 37.1311 39.6916 37.5308 39.3969 37.8255C39.1022 38.1202 38.7025 38.2857 38.2857 38.2857C37.869 38.2857 37.4693 38.1202 37.1746 37.8255C36.8799 37.5308 36.7143 37.1311 36.7143 36.7143V29.5077L26.0396 40.1824C25.7432 40.4687 25.3463 40.6271 24.9342 40.6235C24.5222 40.6199 24.1281 40.4546 23.8367 40.1633C23.5454 39.8719 23.3801 39.4778 23.3765 39.0658C23.3729 38.6537 23.5313 38.2568 23.8176 37.9604L34.4923 27.2857H27.2857C26.869 27.2857 26.4693 27.1201 26.1746 26.8254C25.8799 26.5307 25.7143 26.1311 25.7143 25.7143Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4429 16.4429C20.4249 12.4656 25.9264 10 32 10C38.0736 10 43.5767 12.464 47.5571 16.4429C51.536 20.4249 54 25.9264 54 32C54 38.0736 51.536 43.5767 47.5571 47.5571C43.5783 51.5376 38.0751 54 32 54C25.9249 54 20.4233 51.536 16.4429 47.5571C12.4656 43.5767 10 38.0751 10 32C10 25.9249 12.464 20.4233 16.4429 16.4429ZM32 13.9286C27.0091 13.9286 22.4929 15.9494 19.2211 19.2211C15.9494 22.4929 13.9286 27.0091 13.9286 32C13.9286 36.9909 15.9494 41.5071 19.2211 44.7789C22.4944 48.0506 27.0091 50.0714 32 50.0714C36.9909 50.0714 41.5071 48.0506 44.7789 44.7789C48.0506 41.5056 50.0714 36.9909 50.0714 32C50.0714 27.0091 48.0506 22.4929 44.7789 19.2211C43.1028 17.5403 41.1109 16.2074 38.9178 15.2991C36.7247 14.3908 34.3737 13.925 32 13.9286Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRssLink);
export default __webpack_public_path__ + "static/media/rss_link.8d993db49e1d8ae2b7604e63cf3bc47e.svg";
export { ForwardRef as ReactComponent };